import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Generate and Validate Token", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"margin-top":"25px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PendingItem = _resolveComponent("PendingItem")!
  const _component_ProcessingItem = _resolveComponent("ProcessingItem")!
  const _component_SuccessItem = _resolveComponent("SuccessItem")!
  const _component_FailedItem = _resolveComponent("FailedItem")!
  const _component_van_space = _resolveComponent("van-space")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (!_ctx.showNextButton)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Please wait while the system automatically generates tokens and validates against the access required for the integration. "))
      : (_openBlock(), _createElementBlock("p", _hoisted_3, " The system has completed the verification process, please continue to the next step. ")),
    _createElementVNode("p", null, [
      _createVNode(_component_van_space, {
        direction: "vertical",
        fill: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_ctx.step1state === 0)
              ? (_openBlock(), _createBlock(_component_PendingItem, {
                  key: 0,
                  caption: "Generate Access Tokens"
                }))
              : _createCommentVNode("", true),
            (_ctx.step1state === 1)
              ? (_openBlock(), _createBlock(_component_ProcessingItem, {
                  key: 1,
                  caption: "Processing: Generating access tokens..."
                }))
              : _createCommentVNode("", true),
            (_ctx.step1state === 2)
              ? (_openBlock(), _createBlock(_component_SuccessItem, {
                  key: 2,
                  caption: "Success: Access tokens generated successfully."
                }))
              : _createCommentVNode("", true),
            (_ctx.step1state === 3)
              ? (_openBlock(), _createBlock(_component_FailedItem, {
                  key: 3,
                  caption: "Failure: Error while generating access tokens"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.step2state === 0)
              ? (_openBlock(), _createBlock(_component_PendingItem, {
                  key: 0,
                  caption: "Check Access - EnableWA Organisation"
                }))
              : _createCommentVNode("", true),
            (_ctx.step2state === 1)
              ? (_openBlock(), _createBlock(_component_ProcessingItem, {
                  key: 1,
                  caption: "Processing: Verifying EnableWA organisation access..."
                }))
              : _createCommentVNode("", true),
            (_ctx.step2state === 2)
              ? (_openBlock(), _createBlock(_component_SuccessItem, {
                  key: 2,
                  caption: "Success: Verified EnableWA organisation access."
                }))
              : _createCommentVNode("", true),
            (_ctx.step2state === 3)
              ? (_openBlock(), _createBlock(_component_FailedItem, {
                  key: 3,
                  caption: "Failure: Failed to verify EnableWA organisation access."
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.step3state === 0)
              ? (_openBlock(), _createBlock(_component_PendingItem, {
                  key: 0,
                  caption: "Check Access - Employee List"
                }))
              : _createCommentVNode("", true),
            (_ctx.step3state === 1)
              ? (_openBlock(), _createBlock(_component_ProcessingItem, {
                  key: 1,
                  caption: "Processing: Verifying employee list access..."
                }))
              : _createCommentVNode("", true),
            (_ctx.step3state === 2)
              ? (_openBlock(), _createBlock(_component_SuccessItem, {
                  key: 2,
                  caption: "Success: Verified employee list access."
                }))
              : _createCommentVNode("", true),
            (_ctx.step3state === 3)
              ? (_openBlock(), _createBlock(_component_FailedItem, {
                  key: 3,
                  caption: "Failure: Failed to verify employee list access."
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.step4state === 0)
              ? (_openBlock(), _createBlock(_component_PendingItem, {
                  key: 0,
                  caption: "Check Access - Employee Certifications"
                }))
              : _createCommentVNode("", true),
            (_ctx.step4state === 1)
              ? (_openBlock(), _createBlock(_component_ProcessingItem, {
                  key: 1,
                  caption: "Processing: Verifying employee certifications access..."
                }))
              : _createCommentVNode("", true),
            (_ctx.step4state === 2)
              ? (_openBlock(), _createBlock(_component_SuccessItem, {
                  key: 2,
                  caption: "Success: Verified employee certifications access."
                }))
              : _createCommentVNode("", true),
            (_ctx.step4state === 3)
              ? (_openBlock(), _createBlock(_component_FailedItem, {
                  key: 3,
                  caption: "Failure: Failed to verify employee certifications access."
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", _hoisted_4, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "12" }, {
            default: _withCtx(() => [
              (_ctx.showNextButton)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    (_ctx.time > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createTextVNode(" Validation Timeout "),
                          _createVNode(_component_van_count_down, {
                            time: _ctx.time,
                            format: "mm:ss"
                          }, null, 8, ["time"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, "Validation expired, please start again."))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_row, { justify: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_button, {
                        type: "primary",
                        onClick: _ctx.clickContinueButton,
                        loading: !_ctx.showNextButton || _ctx.nextButtonLoading,
                        disabled: _ctx.nextButtonDisabled || _ctx.time < 1
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Continue ")
                        ]),
                        _: 1
                      }, 8, ["onClick", "loading", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}